var $ = jQuery;
import {debounce} from '../utils/utilities.js';



function expandableResults(component, container, cards) {
  container.css({
    'height': 'auto'
  });

  if(cards.length > 8) {
    let initHeight = 0;

    cards.slice(0, 8).each(function() {
      initHeight += Math.floor($(this).outerHeight(true));
    });

    component.removeClass('non-expandable').addClass('expandable');
    container.css({
      'height': initHeight+'px'
    });
  }
  else {
    component.removeClass('expandable').addClass('non-expandable');
  }
}



function init() {

  var calendarVars = {};

  function resultCardHover() {
      //hover effect
    $('.event-calendar .result-card__title').hover(
      function() {
        $(this).closest('.result-card').addClass('hovered');
      },
      function() {
        $(this).closest('.result-card').removeClass('hovered');
      }
    );
  }

  function setupCalendar() {
    //setupCalendar
    let calendar = {
      resultsContainer : $('.results-wrapper'),
      eventCalendar : $('.event-calendar'),
      resultCard : $('.result-card__event:visible'),
      scrubberContainer : $('.event-calendar__scrubber'),
      scrubberBar : $('.event-calendar__scrubber-bar'),
      positions : {}
    };

    return calendar;
  }

  function calculateStickyScrubber() {
    let begin = $(calendarVars.resultsContainer).offset().top + $(calendarVars.resultCard[0]).height();
    let end = calendarVars.resultsContainer.offset().top + calendarVars.resultsContainer.outerHeight() - $(calendarVars.resultCard[calendarVars.resultCard.length - 1]).height() - $(calendarVars.resultCard[calendarVars.resultCard.length - 2]).height();
    // console.log('begin is ' + begin + ' end is ' + end);
    calendarVars.positions.begin = begin;
    calendarVars.positions.end = end;
  }

  function expandStickyScrubber() {
    let targetHeight = $(calendarVars.resultsContainer).data('height');
    calendarVars.positions.end += targetHeight - calendarVars.resultsContainer.outerHeight();
    // console.log('new end is ' + calendarVars.positions.end);
  }

  function setStickyWidth(element) {
    let currentWidth = element.width();
    element.css({
      width: currentWidth+'px'
    });
  }

  function stickyScrubber() {
    calendarVars = setupCalendar();

    var stickyBar = debounce(function() {
      let scrollPos = $(window).scrollTop();
      if (scrollPos > calendarVars.positions.begin && scrollPos <= calendarVars.positions.end) {
        if(!$('body').hasClass('_sticky')) {
          setStickyWidth(calendarVars.scrubberBar);
          $('body').addClass('_sticky _entry');
        }
      }
      else {
        //fire exit animation
        if ($('body').hasClass('_sticky _entry')) {
          $('body').addClass('_exit');
        }
      }
    }, 10);

    var animationEndHandler = function(event) {
      $('body').removeClass('_sticky _exit _entry');
    };

    var stickyScrubberBinds = function() {
      calculateStickyScrubber();
      $(window).on('scroll', stickyBar);
      $(window).on('rerunStickyScrubber', calculateStickyScrubber);
      $(window).on('resize', calculateStickyScrubber);
      $(document).on('webkitAnimationEnd oanimationend msAnimationEnd animationend', 'body._exit .event-calendar__scrubber', animationEndHandler);
    };

    //bind sticky bar if more than 8 results
    if (calendarVars.resultCard.length > 5) {
      stickyScrubberBinds();
    }

  }

  if ($('.event-calendar').length) {
    calendarVars = setupCalendar();
    //bind hover state on event-result cards
    resultCardHover();

    stickyScrubber();

    //bind custom event for when we need to evaluate if there's need for stickyScrubber
    $(window).on('runStickyScrubber', stickyScrubber);
    $(window).one('readMoreStickyScrubber', expandStickyScrubber);

    expandableResults(calendarVars.eventCalendar, calendarVars.resultsContainer, calendarVars.resultCard);

  }

}


export {init as init, expandableResults};

